module.exports = __webpack_public_path__ + "img/search-button-hover.8a942d3eb15f5386c7efd6ce4e677f1b.svg";